import { useEffect, useMemo, useState } from 'react';

type DocumentBreakpointHook = () => {
  windowWidth: number;
  isDesktopCalendar: boolean;
};

const useDocumentBreakpoint: DocumentBreakpointHook = () => {
  const [windowWidth, setWindowWidth] = useState<number>(window?.innerWidth);

  const handler = () => {
    setWindowWidth(window?.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handler, { passive: true });

    return () => {
      window.removeEventListener('resize', handler);
    };
  }, [windowWidth]);

  return useMemo(() => ({
    windowWidth,
    isDesktopCalendar: windowWidth >= 600,
  }), [windowWidth]);
};

export default useDocumentBreakpoint;
